import { BriefsT } from 'api/cms/briefs/types'
import { appsListUnion } from 'config/apps'
import { AccessGroups } from 'enums/AccessGroups'

export const ResearchBriefsAppsWhitelist = [
  // -------- Covid 19
  AccessGroups.Vaccines,
  AccessGroups.Treatments,
  AccessGroups.CovidCommercialTherapeutics,
  AccessGroups.CovidCommercialVaccines,
  AccessGroups.Epidemiology,

  // -------- Influenza
  AccessGroups.Influenza,
  AccessGroups.InfluenzaCommercial,
  AccessGroups.InfluenzaEpidemiology,

  // -------- RSV
  AccessGroups.RSV,
  AccessGroups.RSVEpidemiology,
  AccessGroups.RSVCommercial,

  // -------- IDA
  AccessGroups.IDA360Vaccines,
  AccessGroups.IDA360Treatments,
  AccessGroups.IDA360ChikV,
  AccessGroups.IDA360Amr,
  AccessGroups.IDA360Malaria,
  AccessGroups.IDA360Dengue,

  // -------- Biorisk
  AccessGroups.Pandemic,
]

export const appsMapping = {
  'IDA 360': { slug: 'ida-360', name: 'IDA 360', parent: 'ida-360' },
  'COVID-19 Vaccines': {
    slug: 'covid-19-vaccines',
    name: 'COVID-19 Vaccines',
    parent: 'covid-19',
  },
  'COVID-19 Treatments': {
    slug: 'covid-19-therapeutics',
    name: 'COVID-19 Therapeutics',
    parent: 'covid-19',
  },
  'COVID-19 Epidemiology': {
    slug: 'epidemiology',
    name: 'COVID-19 Epidemiology',
    parent: 'covid-19',
  },
  'COVID-19 Vaccines Commercial Report': {
    slug: 'covid-19-commercial-vaccines',
    name: 'COVID-19 Vaccines Commercial',
    parent: 'covid-19',
  },
  'COVID-19 Therapeutics Commercial Report': {
    slug: 'covid-19-commercial-therapeutics',
    name: 'COVID-19 Therapeutics Commercial',
    parent: 'covid-19',
  },
  Influenza: { slug: 'influenza', name: 'Influenza', parent: 'influenza' },
  'Influenza Commercial': {
    slug: 'influenza-commercial',
    name: 'Influenza Commercial',
    parent: 'influenza',
  },
  RSV: { slug: 'rsv', name: 'RSV', parent: 'rsv' },
  'RSV Market & Production': {
    slug: 'rsv-commercial',
    name: 'RSV Commercial',
    parent: 'rsv',
  },
  Biorisk: { slug: 'biorisk', name: 'Biorisk', parent: 'biorisk' },
} as { [key: string]: { slug: appsListUnion; name: string; parent: string } }

export function getUniqueValues(arr: any[], property: string): string[] {
  if (!arr) return []
  const uniqueValuesSet = new Set()

  arr.forEach((obj) => {
    if (Array.isArray(obj[property])) {
      obj[property].forEach((value: string) => {
        uniqueValuesSet.add(value)
      })
    }
  })

  return Array.from(uniqueValuesSet) as string[]
}

export function removeDuplicates(array: any[]): BriefsT[] {
  const uniqueMap = new Map()
  for (const item of array) {
    if (!!item) {
      const keyValue = item?.id
      if (!uniqueMap.has(keyValue)) uniqueMap.set(keyValue, item)
    }
  }
  return Array.from(uniqueMap.values())
}

export const areasMapping = {
  TR: 'Treatments',
  VA: 'Vaccines',
}

export function filterBriefs(
  briefs: BriefsT[] | undefined,
  products: string[] | undefined,
  area: string | undefined,
  content: string[] | undefined
) {
  if (!briefs) return []
  const productFilter =
    products && products?.length > 0
      ? briefs.filter((brief) =>
          brief.parentApp.some((app) => {
            return products.includes(app)
          })
        )
      : briefs
  const areaFilter = area
    ? productFilter.filter(
        (brief) => areasMapping[brief.areaOfInterest] === area
      )
    : productFilter

  const contentFilter =
    content && content.length > 0
      ? areaFilter.filter((brief) =>
          brief.areasOfContentType.some((contentType) =>
            content.includes(contentType)
          )
        )
      : areaFilter
  return contentFilter
}
